import { useSearchParams } from "react-router-dom";

export const usePendingResolutionDialogText = () => {
    const [searchParams] = useSearchParams();
    const isCardDeclined = searchParams.get("payment_failed") === "true";

    return isCardDeclined
        ? "Mark as Card Payment Declined"
        : "Mark as Pending session fee";
};
